export default __webpack_public_path__ + "static/media/Carosel HO 1.726ebebd.svg";